import styled from 'styled-components'
import { STRONGORANGE, SILVER, DARKGRAY } from '../../../../styles/colors.style'

export const Header = styled.header`
	border-bottom: 1px solid ${STRONGORANGE};
	padding-bottom: 5px;
	margin-bottom: 20px;
	h2 {
		color: ${STRONGORANGE};
		text-align: center;
		font: 600 25px/32px 'Source Sans Pro';
	}
`

export const List = styled.ul`
	list-style: none;
	margin: 0;
	padding: 0;

	li {
		display: flex;
		justify-content: space-between;
		align-items: center;
		border-bottom: 1px solid ${SILVER};
		height: 50px;

		p {
			margin: 0;
			font: 600 20px/25px 'Source Sans Pro';
			text-transform: uppercase;
			color: ${DARKGRAY};

			&.orange {
				color: ${STRONGORANGE};
			}
		}
	}
`
